<script setup lang="ts">
defineProps<{
    title: string;
    description?: string;
}>();
</script>

<template>
    <section class="grid grid-cols-[260px_1fr] items-start gap-12">
        <div class="flex flex-col">
            <h3 class="text-lg font-semibold text-gray-800">{{ title }}</h3>
            <p v-if="description" class="text-sm text-gray-500">
                {{ description }}
            </p>
        </div>

        <div class="rounded-[12.8px] border border-gray-200 bg-white">
            <slot />
        </div>
    </section>
</template>
